import { z } from "zod/v4";
export const updateProfileInputSchema = z.object({
    display_name: z.string().min(1).optional(),
});
